import { messages as uiMessages } from '@infotech-soe/erp-ui-kit';

const messages = {
  ...uiMessages.uk,
  'core.connectionSplash.connecting': "Встановлення з'єднання з сервером...",

  'core.header.appName': 'ІС "МІА"',

  'core.notification.title': 'Сповіщення',
  'core.errorNotification.copy': 'Копіювати в буфер обміну',
  'core.errorNotification.copied': 'Скопійовано!',
  'core.errorNotification.title': 'Помилка',
  'core.errorNotification.details': 'Технічні подробиці',
  'core.errorNotification.details.type': 'Тип: {type}',
  'core.errorNotification.details.code': 'Код: {code}',
  'core.errorNotification.details.message': 'Повідомлення: {message}',
  'core.errorNotification.details.stack': 'Трасування стеку',
  'core.errorNotification.messages.authFailed': 'Помилка аутентифікації',
  'core.errorNotification.messages.accountBlocked':
    'Обліковий запис заблоковано',
  'core.errorNotification.messages.actionNotPermitted':
    'У вас немає прав для виконання цієї дії',
  'core.errorNotification.messages.appNonAvailable': 'Застосунок недоступний',
  'core.errorNotification.messages.categoryNotPermitted':
    'У вас немає прав на юридичну особу в цій категорії',
  'core.errorNotification.messages.actionCancelled': 'Дію скасовано.',
  'core.errorNotification.messages.systemError': 'Системна помилка',
  'core.errorNotification.messages.notAuthenticated':
    'Ви не автентифіковані. Увійдіть у систему',
  'core.errorNotification.messages.internalApiError':
    'Внутрішня помилка сервера',
  'core.errorNotification.messages.internalProviderError':
    'Внутрішня помилка провайдера бази даних',
  'core.errorNotification.messages.notImplemented': 'Не реалізовано',
  'core.errorNotification.messages.notFound': "Об'єкт не знайдено",
  'core.errorNotification.messages.invalidSchema': 'Некоректна схема даних',
  'core.errorNotification.messages.invalidCategoryType':
    'Некоректний тип категорії',
  'core.errorNotification.messages.invalidDeletionOperation':
    'Некоректна операція видалення',
  'core.errorNotification.messages.invalidCreationOperation':
    'Некоректна операція створення',
  'core.errorNotification.messages.insufficientPermissions':
    'Недостатньо прав для виконання операції',
  'core.errorNotification.messages.invalidSessionToken':
    'Неправильний токен сесії',
  'core.errorNotification.messages.wrongUsernameOrPassword':
    "Неправильне ім'я користувача або пароль",
  'core.errorNotification.messages.sessionVerificationTimeout':
    'Час на верифікацію вже завершився',
  'core.errorNotification.messages.blocked':
    'Цей акаунт тимчасово заблоковано, спробуйте пізніше',
  'core.errorNotification.messages.missingSubsystem':
    'Підсистема є обов’язковою',
  'core.errorNotification.messages.missingCatalog': 'Каталог є обов’язковим',
  'core.errorNotification.messages.unresolvedSubsystem':
    'Категорія не ділиться за підсистемами',
  'core.errorNotification.messages.unresolvedCatalog':
    'Категорія не ділиться за каталогами',
  'core.errorNotification.messages.forbiddenPermission':
    'Вказана комбінація флагів доступу є забороненою',
  'core.errorNotification.messages.notGlobalAdmin':
    'Така операція може бути виконана лише глобальним адміністратором',
  'core.errorNotification.messages.invalidCatalog':
    'Вказано неправильний каталог',
  'core.errorNotification.messages.invalidAction': 'Вказано неправильну дію',
  'core.errorNotification.messages.foreignSubsystem':
    'Немає прав адміністрування у вказаній підсистемі',
  'core.errorNotification.messages.foreignRole':
    'Немає прав адміністрування у підсистемі, до якої належить вказана роль',
  'core.errorNotification.messages.needChangePass': 'Необхідно змінити пароль.',
  'core.errorNotification.messages.noSuchAction': 'Такої дії не існує',
  'core.errorNotification.messages.noSuchCatalog': 'Вказаний каталог не існує',
  'core.errorNotification.messages.noSuchCategory':
    'Вказана категорія не існує',
  'core.errorNotification.messages.noSuchPermission':
    'Вказаний дозвіл не існує',
  'core.errorNotification.messages.noSuchRole': 'Вказана роль не існує',
  'core.errorNotification.messages.noSuchSubsystem':
    'Вказана підсистема не існує',
  'core.errorNotification.messages.samePasswords':
    'Новий пароль повинен відрізнятися від вже існуючого.',
  'core.errorNotification.messages.weakPassword': 'Занадто слабкий пароль.',
  'core.errorNotification.messages.smartCardAuthRequired':
    'Система потребує входу за допомогою КЕП.',
  'core.errorNotification.messages.maxSessionExceeded':
    'Перевищено максимально дозволену кількість одночасних сеансів.',
  'core.errorNotification.messages.logoffTimeout':
    'Перевищено ліміт очікування',
  'core.errorNotification.messages.connectionLost':
    "Втрачено зв'язок з сервером. Спробуйте виконати дію після відновлення зв'язку.",
  'core.errorNotification.messages.passwordExpired':
    'Термін дії пароля закінчився.',
  'core.errorNotification.messages.accountDisabled':
    'Обліковий запис вимкнено.',
  'core.errorNotification.messages.accountLocked':
    'Обліковий запис заблоковано.',
  'core.errorNotification.messages.accountExpired':
    'Термін дії облікового запису закінчився.',
  'core.errorNotification.messages.logonTimeRestriction':
    'Вхід заборонено політикою часу входу.',
  'core.errorNotification.messages.workstationRestriction':
    'Вхід заборонено з цього робочого місця.',
  'core.errorNotification.messages.maxPinnedTabsExceeded':
    'Не можна закріпити більше 5 вкладок.',

  'core.form.validation.tooLong':
    'Значення занадто довге. Поточна довжина: {currentLength}, допустима: {maxLength}',
  'core.form.validation.tooShort':
    'Значення занадто коротке. Поточна довжина: {currentLength}, мінімальна: {minLength}',
  'core.form.validation.rangeOverflowed':
    'Значення перевищує максимально допустиме: {max}',
  'core.form.validation.rangeUnderflowed':
    'Значення менше за мінімально допустиме: {min}',
  'core.form.validation.patternFailed':
    'Значення не відповідає очікуваному формату',
  'core.form.validation.customError': 'Значення некоректне',

  'core.loginForm.login': 'Логін',
  'core.loginForm.password': 'Пароль',
  'core.loginForm.hidePassword': 'Приховати пароль',
  'core.loginForm.showPassword': 'Показати пароль',
  'core.loginForm.application': 'Застосунок',
  'core.loginForm.changePassword': 'Змінити пароль',
  'core.loginForm.newPassword': 'Новий пароль',
  'core.loginForm.newPasswordConfirm': 'Підтвердження',
  'core.loginForm.saveCredentials': "Запам'ятати дані для підпису",
  'core.loginForm.submit': 'Увійти',
  'core.loginForm.error': 'Помилка авторизації',
  'core.loginForm.keyType': 'Тип ключа',
  'core.loginForm.hardwareKey': 'Апаратний ключ',
  'core.loginForm.fileKey': 'Файловий ключ',
  'core.loginForm.deviceType': 'Тип пристрою',
  'core.loginForm.authority': 'КНЕДП/АЦСК:',
  'core.loginForm.device': 'Пристрій',
  'core.loginForm.header': 'Вхід',
  'core.loginForm.loginSubtitle': 'Введіть свій логін і пароль',
  'core.loginForm.windowsADSubtitle':
    'Введіть свій корпоративний логін і пароль',
  'core.loginForm.tab.login': 'По паролю',
  'core.loginForm.tab.digitalSignature': 'КЕП',
  'core.loginForm.tab.windowsAD': 'Корпоративний',
  'core.loginForm.noAvailableApps': 'Немає доступних застосунків.',
  'core.loginForm.noAuthMethods': 'Сервер не надає послуг автентифікації.',
  'core.loginForm.wrongTimeZone': `Часовий пояс, встановлений на вашому комп'ютері відрізняється від часового поясу сервера. Будь ласка, встановить часовий пояс "{tz}" та не змінюйте його до закінчення роботи з системою.`,
  'core.loginForm.cannotConnectToServer': `Не вдається з'єднатися з сервером застосунків.`,
  'core.loginForm.tryToReconnectLater': `Перевірте підключення до мережі та спробуйте оновити сторінку ще раз.`,
  'core.loginForm.notAvailableForm.title':
    'Для входу перевірте наявність наступних компонентів:',
  'core.loginForm.notAvailableForm.agentLink': 'агент підпису',
  'core.loginForm.notAvailableForm.javaLink':
    'середовища для виконання java додатків',
  'core.loginForm.notAvailableForm.access':
    'Також Ви маєте бути певні, що маєте право доступу',
  'core.loginForm.userGuide': 'Посібник користувача',

  'core.title.documentTitle': '{routeTitle} - {appName}',
  'core.title.documentContentTitle':
    '{contentTitle} - {routeTitle} - {appName}',
  'core.title.routes.root': 'Вхід',
  'core.title.routes.notFound': 'Не знайдено',

  'core.appMenu.addToPanelLinks': 'Додати до панелі швидкого доступу',
  'core.appMenu.openNewTab': 'Відкрити в новій вкладці',
  'core.appMenu.activateTab': 'Перейти на відкриту вкладку',
  'core.appMenu.openWithDefaults':
    'Відкрити категорію з налаштуваннями за замовчанням',
  'core.appMenu.search': 'Пошук в меню',
  'core.appMenu.open': 'Відкрити меню ({hotkey})',
  'core.appMenu.close': 'Закрити меню ({hotkey})',
  'core.appMenu.categories': 'Категорії',

  'core.preferencesDialog.title': 'Налаштування',
  'core.preferencesDialog.about': 'Про програму',
  'core.preferencesDialog.system':
    'Комп’ютерна програма "Інструментальне програмне забезпечення "МІА"\nверсія сервера {serverVersion}\nверсія клієнта {clientVersion}',
  'core.preferencesDialog.systemCopyright':
    '© 2018-2026 Державне підприємство «ІНФОТЕХ»',
  'core.preferencesDialog.projectInfo': `{name}\n версія {version}`,
  'core.preferencesDialog.copyright':
    '© {year} Державне підприємство «ІНФОТЕХ»',
  'core.preferencesDialog.schemas': 'Схеми',
  'core.preferencesDialog.schemas.purgeCache': 'Очистити кеш',
  'core.preferencesDialog.theme': 'Тема',
  'core.preferencesDialog.theme.modern': 'Сучасна',
  'core.preferencesDialog.theme.modernCompact': 'Сучасна (компактна)',
  'core.preferencesDialog.theme.modernCompactBlue':
    'Сучасна (компактна, блакитна)',
  'core.preferencesDialog.theme.modernCompactBurgundy':
    'Сучасна (компактна, бургундія)',
  'core.preferencesDialog.theme.yellowBlue': 'Жовто-блакитна',
  'core.preferencesDialog.theme.yellowBlueCompact':
    'Жовто-блакитна (компактна)',
  'core.preferencesDialog.theme.rainyDay': 'Дощовий день',
  'core.preferencesDialog.theme.khaki': 'Хакі',
  'core.preferencesDialog.theme.deepOcean': 'Глибокий океан (темна)',
  'core.preferencesDialog.theme.moonlitSky': 'Місячне небо (темна)',
  'core.preferencesDialog.theme.green': 'Зелена',
  'core.preferencesDialog.session.signOut': 'Вийти',

  'core.category.grid.ag.of': 'з',
  'core.category.grid.ag.to': 'по',
  'core.category.grid.ag.notSet': 'Не задана',

  'core.category.grid.config.title': 'Налаштування та стилізація даних',
  'core.category.grid.config.preset.add': 'Додати шаблон',
  'core.category.grid.config.preset.delete': 'Видалити шаблон',
  'core.category.grid.config.preset.rename': 'Перейменувати шаблон',
  'core.category.grid.config.preset.import': 'Імпортувати шаблон',
  'core.category.grid.config.preset.reset': 'Скинути налаштування шаблона',
  'core.category.grid.config.preset.export': 'Експортувати шаблон',
  'core.category.grid.config.pinned': 'Кількість закріплених стовпців',
  'core.category.grid.config.visibility': 'Відображати',
  'core.category.grid.config.columnName': 'Назва колонки',
  'core.category.grid.config.rules.edit': 'Редагувати',
  'core.category.grid.config.rules.copyOf': 'Копія',
  'core.category.grid.config.rules.preset': 'Шаблон',
  'core.category.grid.config.rules.condition.add': 'Додати умову',
  'core.category.grid.config.rules.condition.delete': 'Видалити умову',
  'core.category.grid.config.rules.condition': 'Умова',
  'core.category.grid.config.rules.style': 'Стиль',
  'core.category.grid.config.rules.font': 'Шрифт',
  'core.category.grid.config.rules.style.text': 'Колір тексту',
  'core.category.grid.config.rules.style.background': 'Колір фону',
  'core.category.grid.config.rules.style.text.bold': 'Жирний',
  'core.category.grid.config.rules.style.text.italic': 'Курсив',
  'core.category.grid.config.rules.style.text.underline': 'Підкреслений',
  'core.category.grid.config.rules.style.text.lineThrough': 'Закреслений',
  'core.category.grid.config.rules.style.text.example':
    'Приклад комірки {parity, select, odd {(непарна)} even {(парна)} other {}}',
  'core.category.grid.config.rules.pattern': 'Патерн',
  'core.category.grid.config.rules.caseSensitive': 'Чутливість регістра',
  'core.category.grid.config.rules.date.start': 'Від',
  'core.category.grid.config.rules.date.end': 'До',
  'core.category.grid.config.rules.number.greater': 'Більше ніж',
  'core.category.grid.config.rules.number.less': 'Менше ніж',
  'core.category.grid.config.rules.emptyValue': 'Немає значення',
  'core.category.grid.config.rules.notEmptyValue': 'Є значення',
  'core.category.grid.config.rules.forRow': 'Застосувати до всього рядка',
  'core.category.grid.config.tab.columns': 'Колонки',
  'core.category.grid.config.tab.design': 'Стилізація',
  'core.category.grid.config.tab.other': 'Інше',
  'core.category.grid.config.tab.other.caseInsensitive':
    'Не враховувати регістр символів',
  'core.category.grid.config.tab.other.locateNode':
    'Позиціонуватися в режимі списку',
  'core.category.grid.config.tab.other.recordView': 'Перегляд запису',
  'core.category.grid.config.tab.other.showDictionaryCondition':
    'Відображати форму фільтру в режимі словника',
  'core.category.grid.config.tab.actions': 'Дії',
  'core.category.grid.config.tab.actions.useDefault':
    'Використовувати за замовчанням',
  'core.category.grid.config.tab.actions.inToolbar':
    'Відображати на панелі дій',
  'core.category.grid.config.tab.actions.inMenu': 'Відображати в меню',
  'core.category.grid.config.tab.actions.showInToolbarHint':
    'Увімкнути всі команди на панелі дій',
  'core.category.grid.config.tab.actions.hideInToolbarHint':
    'Вимкнути всі команди з панелі дій',
  'core.category.grid.config.tab.actions.showInMenuHint':
    'Увімкнути всі команди в контекстному меню',
  'core.category.grid.config.tab.actions.hideInMenuHint':
    'Вимкнути всі команди з контекстного меню',
  'core.category.grid.config.tab.other.rowsLimitInDataset':
    "Обмежувати об'єм вибірки",
  'core.category.grid.config.tab.other.hideZeroValues':
    'Не відображати нульові значення',
  'core.category.grid.config.table.field': 'Поле',
  'core.category.grid.config.table.value': 'Значення',
  'core.category.grid.config.table.color': 'Колір тексту',
  'core.category.grid.config.table.backgroundColor': 'Колір фону',
  'core.category.grid.config.formulas.title': 'Формули для підсумків',
  'core.category.grid.config.formulas.deleteAll': 'Видалити всі умови',
  'core.category.grid.config.formulas.attachmentByAll': 'За всіма рядками',
  'core.category.grid.config.formulas.attachmentBySelected':
    'За обраними рядками',
  'core.category.grid.config.totals': 'Налаштування підсумків',
  'core.category.grid.config.formulas.sum': 'Сума',
  'core.category.grid.config.formulas.avg': 'Середнє',
  'core.category.grid.config.formulas.min': 'Мінімум',
  'core.category.grid.config.formulas.max': 'Максимум',
  'core.category.grid.counter.total': 'Всього: {counter, number}',
  'core.category.grid.counter.found': 'Відібрано: {counter, number}',
  'core.category.grid.counter.selected': 'Відмічено: {counter, number}',
  'core.category.grid.filter.off': 'Вимкнути фільтрацію по колонках',

  'core.category.grid.totals.title': 'Підсумки',
  'core.category.grid.totals.updateData': 'Оновіть дані (F5)',

  'core.category.grid.search.contains': 'Пошук всередині рядка',
  'core.category.grid.search.caseSensitive': 'З урахуванням регістру',
  'core.category.grid.search.prev': 'Попереднє співпадіння (▲)',
  'core.category.grid.search.next': 'Наступне співпадіння (▼)',

  'core.category.grid.excelExport.title': 'Експорт в Excel',
  'core.category.grid.excelExport.mainTable': 'Головна таблиця',
  'core.category.grid.excelExport.secondary': 'Підлегла таблиця',
  'core.category.grid.excelExport.mainSelected': 'Відмічені рядки',
  'core.category.grid.excelExport.mainAll': 'Всі рядки',
  'core.category.grid.excelExport.secondaryNone': 'Не експортувати',
  'core.category.grid.excelExport.secondaryTogether': 'Експортувати разом',
  'core.category.grid.excelExport.secondaryTogetherAll':
    'Експортувати разом (всі)',
  'core.category.grid.excelExport.secondarySeparate': 'Експортувати окремо',
  'core.category.grid.excelExport.secondarySeparateAll':
    'Експортувати окремо (всі)',

  'core.category.commands.create': 'Створити',
  'core.category.commands.duplicate': 'Дублювати',
  'core.category.commands.delete': 'Видалити',
  'core.category.commands.edit': 'Редагувати',
  'core.category.commands.update': 'Оновити',
  'core.category.commands.restoreLink': 'Відновити контроль',
  'core.category.commands.weakenLink': 'Зняти контроль',
  'core.category.commands.linkFile': 'Приєднати файл',
  'core.category.commands.view': 'Переглянути',
  'core.category.commands.filter': 'Фільтрувати',
  'core.category.commands.filterByColumn': 'Фільтрувати по колонці',
  'core.category.commands.clearColumnsFilters': 'Очистити фільтри по колонках',
  'core.category.commands.move': 'Перемістити',
  'core.category.commands.pivot': 'Багатовимірні звіти',
  'core.category.commands.copy': 'Копіювати комірку',
  'core.category.commands.import': 'Імпортувати',
  'core.category.commands.export': 'Експортувати в CSV',
  'core.category.commands.excelExport': 'Експортувати в Excel',
  'core.category.commands.settings': 'Налаштування',
  'core.category.commands.toolbar': 'Панель дій',
  'core.category.commands.catalogs': 'Панель каталогів',
  'core.category.commands.watch': 'Перегляд',
  'core.category.commands.review': 'Перегляд запису',
  'core.category.commands.downloadFile': 'Завантажити файл',
  'core.category.commands.print': 'Друк звiту',
  'core.category.commands.planTable': 'Плановий час',
  'core.category.commands.factTable': 'Фактично відпрацьований час',
  'core.category.commands.calendarTable': 'Робочі календарі',
  'core.category.commands.timeBoard': 'Табель',
  'core.category.commands.docLinksGraph': "Зв'язки документів",
  'core.category.commands.accessRightsAssignment': 'Призначення прав доступу',
  'core.category.commands.linkedFiles': 'Приєднані файли',
  'core.category.commands.actionHistory': 'Історія дій',
  'core.category.commands.calculate': 'Перерахувати',
  'core.category.commands.check': 'Перевірити',
  'core.category.commands.showCheck': 'Протоколи перевірок',
  'core.category.commands.inputDocs': 'Вхідні документи',
  'core.category.commands.outputDocs': 'Вихідні документи',
  'core.category.commands.sign': 'Підписати',
  'core.category.commands.storeValues': 'Зберегти значення',
  'core.category.commands.reports': 'Звіти',

  'core.category.tree.catalogs': 'Каталоги',
  'core.category.tree.catalogs.create': 'Створити каталог',
  'core.category.tree.catalogs.create.title': 'Створення каталогу',
  'core.category.tree.catalogs.create.question': 'Назва каталогу:',
  'core.category.tree.catalogs.delete': 'Видалити каталог',
  'core.category.tree.catalogs.delete.short': 'Видалити каталог?',
  'core.category.tree.catalogs.delete.long':
    'Обраний каталог буде видалено з системи.',
  'core.category.tree.catalogs.rename': 'Перейменувати каталог',
  'core.category.tree.catalogs.rename.title': 'Перейменування каталогу',
  'core.category.tree.catalogs.rename.question': 'Назва каталогу:',
  'core.category.tree.catalogs.refresh': 'Оновити',
  'core.category.tree.catalogs.hierarchy': 'Список',
  'core.category.tree.catalogs.clear': 'Очистити позначки',
  'core.category.tree.catalogs.move': 'Перемістити каталог',
  'core.category.tree.catalogs.move.short': 'Перемістити каталог?',
  'core.category.tree.catalogs.move.long':
    'Каталог буде переміщено в ієрархії до нового батьківського каталогу.',
  'core.category.tree.catalogs.moveIn.short': 'Перемістити запис (записи)?',
  'core.category.tree.catalogs.moveIn.long':
    '{count, plural, one {Запис буде переміщено} other {Записи будуть переміщені}} в каталог "{nodeName}"',
  'core.category.tree.catalogs.cut': 'Вирізати',
  'core.category.tree.catalogs.paste': 'Вставити',
  'core.category.tree.hierarchy': 'Ієрархія',
  'core.category.tree.catalogs.toggle':
    'Позначити/зняти позначки у всієї гілки',
  'core.category.tree.hierarchy.move.short': 'Перемістити запис (записи)?',
  'core.category.tree.hierarchy.move.long':
    '{count, plural, one {Запис буде переміщено} other {Записи будуть переміщені}} в елемент структури "{nodeName}"',

  'core.confirmation.title': 'Підтвердження дії',
  'core.confirmation.generic': 'Виконати дію "{commandName}"?',
  'core.confirmation.print': 'Відправити завдання на сервер друку?',
  'core.confirmation.generic.long':
    'Операція не може бути скасована після виконання.',
  'core.confirmation.print.long':
    'Після закінчення друку Ви отримаєте сповіщення.',
  'core.confirmation.delete': 'Видалити запис?',
  'core.confirmation.delete.long':
    'Обраний запис буде повністю видалено з бази, якщо це дозволено.',

  'core.notFound.title': 'Сторінка не знайдена',
  'core.notFound.description':
    'На жаль, запитуваної вами сторінки за даною адресою не існує.',
  'core.notFound.submit': 'На головну сторінку',

  'core.form.close': 'Закрити',
  'core.form.ok': 'Ok',
  'core.form.apply': 'Застосувати',
  'core.form.prev': 'Попередня',
  'core.form.next': 'Наступна',
  'core.form.print': 'Друк',
  'core.form.showHints': 'Показати підказки',
  'core.form.hideHints': 'Сховати підказки',
  'core.form.select.all': 'Всі',
  'core.form.expand': 'Розгорнути',
  'core.form.collapse': 'Згорнути',

  'core.signForm.title': 'Оберіть ключ для електронного підпису',

  'core.dictionary.save': 'Вибрати',
  'core.dictionary.next': 'Далi',

  'core.worktable.typePlan': 'Плановий час',
  'core.worktable.typeFact': 'Фактично відпрацьований час',
  'core.worktable.typeCalendar': 'Робочі календарі',
  'core.worktable.timeBoard': 'Табель обліку робочого часу',
  'core.worktable.requisites': 'Реквізити',
  'core.worktable.employee': 'Співробітник',
  'core.worktable.employeeNumber': 'Табельний номер',
  'core.worktable.period': 'Період',
  'core.worktable.workSchedule': 'Графік робіт',
  'core.worktable.norm': 'Норма',
  'core.worktable.plan': 'План',
  'core.worktable.fact': 'Факт',
  'core.worktable.hours': 'Години',
  'core.worktable.days': 'Дні',
  'core.worktable.workDays': 'Дні роботи',
  'core.worktable.workHours': 'Години роботи',
  'core.worktable.hoursTotal.base': 'Основні години',
  'core.worktable.hoursTotal.presence': 'Усього за дні виходу',
  'core.worktable.hoursTotal.absence': 'Усього за дні невиходу',
  'core.worktable.hoursTotal.summary': 'Усього',
  'core.worktable.hours.number': '№',
  'core.worktable.hours.type': 'Тип годин',
  'core.worktable.format': 'Формувати',

  'core.rolePrivs.title': 'Призначення прав доступу',
  'core.rolePrivs.catalog': 'За каталогами',
  'core.rolePrivs.subdivision': `За суб'єктами обліку`,
  'core.rolePrivs.hierarchy': 'По вузлах ієрархії',
  'core.rolePrivs.privsAll': 'В категорії',
  'core.rolePrivs.inheritPrivs': 'Наслідувати права',
  'core.category.tree.catalogs.grantAllCatalogPrivs':
    'Призначити права на всі дії з каталогом',
  'core.category.tree.catalogs.grantAllCategoryPrivs':
    'Призначити права на всі дії в категорії',
  'core.category.tree.catalogs.revokeAllCategoryPrivs':
    'Видалити права на всі дії в категорії',
  'core.rolePrivs.subdivisionTitle': "Суб'єкти обліку (підрозділи)",
  'core.rolePrivs.actions.title.catalogs': 'Дії з каталогом',
  'core.rolePrivs.actions.title.category': 'Дії категорії',
  'core.rolePrivs.actions.title.hierarchy': 'Дії категорії у дочірніх вузлах',

  'core.date.months':
    'Січень_Лютий_Березень_Квітень_Травень_Червень_Липень_Серпень_Вересень_Жовтень_Листопад_Грудень',
  'core.date.weekDays':
    "Понеділок_Вівторок_Середа_Четвер_П'ятниця_Субота_Неділя",
  'core.date.month': 'Місяць',
  'core.date.year': 'Рік',

  'core.category.grid.config.preset.current': 'Обраний шаблон',
  'core.category.grid.config.rules.style.text.err':
    'текст і фон мають однаковий колір',
  'core.category.grid.config.preset.copy': 'Копіювати шаблон',
  'core.category.grid.config.preset.rename.dialog.title': 'Нова назва',
  'core.category.grid.config.preset.rename.dialog.label':
    'Введіть назву шаблону',

  'core.docLinksGraph.title': "Зв'язки документів",
  'core.docLinksGraph.open': 'Переглянути документи',
  'core.docLinksGraph.changeEdges': "Перебудувати взаємозв'язки",
  'core.docLinksGraph.data.description': 'Відсутній опис документа',
  'core.docLinksGraph.expand': "Розгорнути зв'язки",
  'core.docLinksGraph.collapse': "Згорнути зв'язки",
  'core.docLinksGraph.documentsCount':
    '{count, plural, one {# документ} few {# документи} many {# документів} other {# документа}}',

  'core.pivotReport.preset': 'Шаблон {name}',
  'core.pivotReport.openPreset': 'Відкрити шаблон',
  'core.pivotReport.savePreset': 'Зберегти шаблон',
  'core.pivotReport.overwritePreset': 'Перезаписати існуючий шаблон "{name}"?',
  'core.pivotReport.presetInputLabel': 'Назва шаблону',
  'core.pivotReport.otientation.title': 'Оберіть орієнтацію сторінок звіту',
  'core.pivotReport.orientation.landscape': 'Альбомна',
  'core.pivotReport.orientation.portrait': 'Книжкова',

  'core.balance.saveChanges': 'Зберегти зміни?',
  'core.balance.pinArea': 'Зафіксувати область',
  'core.balance.unpinArea': 'Зняти фіксацію області',
  'core.balance.addFromDict': 'Додати із словника',
  'core.balance.consState': 'Склад показника',
  'core.balance.consStateSection': 'Склад показника за розрізами',
  'core.balance.index': 'Показник',
  'core.balance.group': 'Група',
  'core.balance.linkedIndex': "Зв'язаний показник",
  'core.balance.addRecord': 'Додати запис',
  'core.balance.duplicateRecord': 'Дублювати запис',
  'core.balance.removeRecord': 'Видалити запис',
  'core.balance.indexPanel': 'Панель показника',
  'core.balance.parametersSection': 'Параметри',
  'core.balance.category': 'Категорія',
  'core.balance.extraDict': 'Додатковий довідник',
  'core.balance.manualFill': 'Ручне заповнення',
  'core.balance.isMandatory': "Обов'язковий",
  'core.balance.mandatoryHint': "Обов'язковий показник має бути заповнений.",
  'core.balance.multiSelect': 'Мультивибір',
  'core.balance.validation': 'Валідація',
  'core.balance.validationError': 'Повідомлення про помилку',
  'core.balance.yes': 'Так',
  'core.balance.no': 'Ні',

  'core.lookupBox.updater': 'Згенерувати',
  'core.lookupBox.dictionary': 'Відкрити словник',

  'core.systemNotification.maintenance':
    'В період з {startTs} по {finishTs} заплановано проведення технічних робіт. В цей час можливі перебої в работі системи.',
  'core.systemNotification.upgrade':
    'В період з {startTs} по {finishTs} заплановано оновлення системи. Прохання утриматися від роботи в цей час.',

  'core.connectionStatus.connected': `Зв'язок із сервером застосунків встановлено`,
  'core.connectionStatus.disconnected': `Немає зв'язку із сервером застосунків`,
  'core.connectionStatus.inProgress': `Ви не аутентифіковані`,

  'core.contentTab.pin': 'Закріпити',
  'core.contentTab.unpin': 'Відкріпити',
  'core.contentTab.close': 'Закрити категорію',

  'core.actionProgress.cancelling': 'Скасовується...',
} as const;

export type MessageKey = keyof typeof messages;

export default messages;
